$(document).ready(function () {

    // Removed .prd_dynamic_cart handler - now using theme's default product-form component
    // The button in site1-featured-collection.liquid now uses <product-form> which handles add to cart automatically
    
    
    //Site 1 Marquee slider
        if($("#slider--top").length != 0) {
    
            new Splide("#slider--top", {
                type: "loop",
                autoWidth: true,
                autoplay: true,
                interval: 1,
                speed: 100000,
                direction: "ltr",
                arrows: false,
                pagination: false,
                pauseOnHover: false,
                pauseOnFocus: false,
                gap: '50px'
            }).mount();
        }
    //Site 1 Featured collection product slider
        if($(".prod-slider").length != 0) {
    
        new Splide('.prod-slider', {
         type: "loop",
        perPage: 3,
        autoplay: true,
         interval: 5000,
        gap: '100px',
        arrows: true,
        pagination: false,
        breakpoints: {
          768: { perPage: 1 },
          1024: { perPage: 3 }
        }
      }).mount();
    }
    
      
    // Testimonials Video Slider (single = 1 slide on mobile, dual = 2 slides on mobile)
      var $videosGrid = $(".reviews-sec .videos-grid");
      if ($videosGrid.length !== 0) {
        var isDual = $videosGrid.hasClass("dual");
        var mobilePerPage = isDual ? 2 : 1;
        new Splide(".reviews-sec .videos-grid", {
          perPage: 4,
          drag: false,
          dragAngleThreshold: 0,
          gap: "55px",
          arrows: true,
          autoplay: false,
          pagination: true,
          breakpoints: {
            500: {
              perPage: mobilePerPage,
              drag: true
            },
            820: {
              perPage: 2,
              drag: true,
              gap: "45px"
            },
            1200: {
              perPage: 3,
              drag: false,
              gap: "55px",
            }
          }
        }).mount();
      }
    
    
    //TEstimonaials Review Slider 
        if($(".testimonials-slider").length != 0) {
    
       new Splide('.testimonials-slider', {
            perPage: 3,
            gap: '45px',
            arrows: true,
            autoplay: false,
             interval: 1000,
            pagination: false,
            breakpoints: {
                768: { perPage: 1 },
                1024: { perPage: 2 }
            }
        }).mount();
    }
    
        if($(".reviews-sec").length != 0) {
    
            //TEstimonaials On play button click play video and overlay
            document.querySelectorAll(".reviews-sec").forEach(function (reviewsSec) {
            const videos = reviewsSec.querySelectorAll(".video-element");
    
            videos.forEach(function (video) {
                let overlay = video.parentElement.querySelector(".overlay-content");
    
                if (overlay) {
                // Function to pause other videos
                function pauseOthers() {
                    videos.forEach(function (otherVideo) {
                    if (otherVideo !== video) {
                        otherVideo.pause();
                        let otherOverlay = otherVideo.parentElement.querySelector(".overlay-content");
                        if (otherOverlay) otherOverlay.style.display = "";
                    }
                    });
                }
    
                // Click overlay → play video + hide overlay
                overlay.addEventListener("click", function () {
                    pauseOthers();
                    video.play();
                    overlay.style.display = "none";
                });
    
                // Click video → toggle pause/play
                // video.addEventListener("click", function () {
                //     if (!video.paused) {
                //     // Pause current video and restore overlay
                //     video.pause();
                //     overlay.style.display = "";
                //     }
                // });
    
                // When video pauses → show overlay
                video.addEventListener("pause", function () {
                    overlay.style.display = "";
                });
    
                // When video ends → show overlay again
                video.addEventListener("ended", function () {
                    overlay.style.display = "";
                });
                }
            });
            });
        }
    
        //Custom Search icon header on click trigger search form
        if($(".site1_header_serach_frm .site-search-handle").length != 0) {
            document.querySelector('.site1_header_serach_frm .site-search-handle')?.addEventListener('click', function (e) {
                e.preventDefault();
                    const mobileSearchElements = document.querySelectorAll('.site1_pages .mobile-left-icons .site-search-handle');
                    
                    if (mobileSearchElements.length > 0) {
                    
                        mobileSearchElements.forEach(el => {
                            
                            el.dispatchEvent(new MouseEvent('click', {
                                bubbles: true,
                                cancelable: true,
                                view: window
                            }));
                        });
                    }
    
            });
        }
    });
    
    
    gsap.registerPlugin(ScrollTrigger);
     
    gsap.fromTo(
        [".point-1", ".point-2", ".point-3"],
        { x: -50, opacity: 0 },
        {
            x: 0,
            opacity: 1,
            duration: 0.6,
            stagger: 0.3,
            ease: "power2.out",
            scrollTrigger: {
                trigger: ".prod-left",
                start: "top 80%",  
                toggleActions: "play none none none",
               
            }
        }
    );
     
    gsap.fromTo(
        [".point-4", ".point-5", ".point-6"],
        { x: 50, opacity: 0 },
        {
            x: 0,
            opacity: 1,
            duration: 0.6,
            stagger: 0.3,
            ease: "power2.out",
            delay: 0.9,
            scrollTrigger: {
                trigger: ".prod-left",
                start: "top 80%",
                toggleActions: "play none none none",
               
            }
        }
    );
    
    gsap.registerPlugin(ScrollTrigger);
    
    gsap.utils.toArray('.shopify-section').forEach(section => {
      const headings = section.querySelectorAll('h2');
      
      headings.forEach(heading => {
        gsap.from(heading, {
          opacity: 0,
          y: 30,
          duration: 1,
          scrollTrigger: {
            trigger: heading,       
            start: "top 80%",       
            toggleActions: "play none none none"
          }
        });
      });
    });
    
    
    
    $(document).ready(function () {
        if($("#thumbnail-slider").length != 0) {
            let thumbs = new Splide('#thumbnail-slider', {
               perPage: 5,
                fixedWidth   : 80,
                fixedHeight  : 80,
                gap          : 10,
                pagination   : false,
                direction    : 'ttb',   // vertical
                height       : '500px',
                focus        : 'center', 
                isNavigation : true,    
                breakpoints: {
                820: { perPage: 4, height : '400px', },
                767: {  direction    : 'ltr', perPage: 4, height : 'auto' }
            } 
        
            });
    
            thumbs.on('moved', function (newIndex) {
                // get the active slide
                let activeSlide = thumbs.Components.Slides.getAt(newIndex).slide;
                let mediaId = activeSlide.getAttribute('data-mediaId');
                let targetBtn = document.querySelector(
                    '.product-gallery__thumbnails button[data-mediaId="' + mediaId + '"]'
                );
    
                if (targetBtn) {
                    targetBtn.click();
                }
    
                // also force the main image to update (css-slider aware)
                let imgEl = activeSlide.querySelector('img');
                let srcEl = imgEl && (imgEl.currentSrc || imgEl.src);
                if (srcEl && window._site1ActivateMainByImgSrc) {
                    window._site1ActivateMainByImgSrc(srcEl);
                }
            });
    
            thumbs.mount();
            window._site1Thumbs = thumbs;
    
            if (typeof mediaactiveId !== 'undefined' && mediaactiveId) {
            
              // Auto-activate current variant media
              let targetIndex = [...document.querySelectorAll('#thumbnail-slider .splide__slide')]
              .findIndex(el => el.dataset.mediaId === mediaactiveId);
              if (targetIndex >= 0) {
                thumbs.go(targetIndex);
              }
            }
        }
    });
    
    /* NEW: Sync main image when any native product thumbnail is clicked */
    document.addEventListener('click', function(e){
      let btn = e.target.closest('.product-gallery__thumbnails button');
      if (!btn) return;
      let img = btn.querySelector('img');
      let src = img && (img.currentSrc || img.src);
      if (src && window._site1ActivateMainByImgSrc){
        window._site1ActivateMainByImgSrc(src);
      }
    });
    
    /* NEW: Also handle clicks inside our Splide thumbnail rail */
    document.addEventListener('click', function(e){
      let slide = e.target.closest('#thumbnail-slider .splide__slide');
      if (!slide) return;
      let img = slide.querySelector('img');
      let src = img && (img.currentSrc || img.src);
      if (src && window._site1ActivateMainByImgSrc){
        window._site1ActivateMainByImgSrc(src);
      }
    });
    
    // modal
      const modal = document.getElementById('cm_modal');
      const closeEls = modal.querySelectorAll('[data-close]');
      let lastFocused = null;
    
      const FOCUSABLE = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])';
    
      function openCmModal(selector_content) {
        console.log("OPEN CM MODAL");
        if(selector_content){
            
            const selector_contentEl = document.querySelector(selector_content);
            const cm_modal__content = document.querySelector('.cm_modal__content');
            cm_modal__content.innerHTML="";
            if(selector_contentEl){
                  cm_modal__content.innerHTML=selector_contentEl.innerHTML;
            }
        }
        lastFocused = document.activeElement;
        modal.classList.add('is-open');
        modal.removeAttribute('aria-hidden');
        // move focus inside
        const first = modal.querySelector(FOCUSABLE);
        if (first) first.focus();
        document.addEventListener('keydown', onCmKeydown);
      }
    
      function closeCmModal() {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.removeEventListener('keydown', onCmKeydown);
        if (lastFocused) lastFocused.focus();
      }
    
      function onCmKeydown(e) {
        if (e.key === 'Escape') return closeCmModal();
        if (e.key === 'Tab') trapCmFocus(e);
      }
    
      function trapCmFocus(e) {
        const focusables = modal.querySelectorAll(FOCUSABLE);
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    
      closeEls.forEach(el => el.addEventListener('click', closeCmModal));
      // Prevent clicks inside the dialog from bubbling to overlay
      modal.querySelector('.cm_modal__dialog').addEventListener('click', (e) => e.stopPropagation());
      // Clicking overlay closes
      modal.addEventListener('click', (e) => {
        if (e.target.hasAttribute('data-close')) closeCmModal();
      });
    
    
    //Add to cart custom with subcription plan
    
    document.querySelectorAll('a[href*="#faqs-section"]').forEach(link => {
      link.addEventListener('click', e => {
           let checkfaq = movetofaq();
            if(!checkfaq){
                  e.preventDefault();
    
            }
      });
    });
    
    // Helper: check if header visible
    function isElementInViewport(el) {
      const rect = el.getBoundingClientRect();
      return rect.bottom > 0 && rect.top < window.innerHeight;
    }
    
    // Helper: check if header visible
    function movetofaq() {
     
         const faqItems = document.querySelector('.faq-items .faq_text_container');
          if (!faqItems) return true;
          document.querySelector('.sidebar__close')?.click();
    
          // Calculate top offset
          const header = document.querySelector('#site-header');
          const headerHeight = header && header.offsetHeight && isElementInViewport(header)
            ? header.offsetHeight
            : 0;
    
          const offsetTop = faqItems.getBoundingClientRect().top + window.scrollY - headerHeight;
    
          // Smooth scroll
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
    
          // Animate first FAQ item
          const firstItem = faqItems.firstElementChild;
          if (firstItem) {
            firstItem.classList.add('highlight-anim');
            setTimeout(() => firstItem.classList.remove('highlight-anim'), 1200);
          }
          return false;
    }
    
    document.addEventListener("DOMContentLoaded", function () {
      //Add to cart custom with subcription plan
      document.querySelectorAll(".cm-add-to-cart").forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          document.querySelectorAll('.custom-error-message').forEach(el => el.remove());
    
          // 1. Find parent form
          const form = btn.closest("form");
          if (!form) return;
          // Check Recharge widget radio buttons
          const rcInput = form.querySelector(".rc_widget__option__input:checked");
          const inputContainer = form.querySelector(".cm-variants-grid-container");
          if(inputContainer){
            inputContainer.classList.remove("is--error");
          }
          let sellingplan = "";
    
          // If Recharge radio buttons exist
          if (rcInput) {
            if (rcInput.value == "onetime") {
              sellingplan = ""; // force one-time → no selling plan
            } else {
              // fallback to dropdown selection
              const dropdown = form.querySelector("select.rc-selling-plans__dropdown");
              sellingplan = dropdown ? dropdown.value : "";
            }
          } else {
            // No radio widget, fallback to dropdown
            const dropdown = form.querySelector("select.rc-selling-plans__dropdown");
            sellingplan = dropdown ? dropdown.value : "";
          }
    
        
    
          let hasValidQty = false;
          let items = [];
    
          // 3. Loop over all qty inputs
          form.querySelectorAll(".cm-variant-qty").forEach(function (qtyInput) {
            const qty = parseInt(qtyInput.value, 10) || 0;
            const itemIndex = qtyInput.getAttribute("data-index");
            const itemWrapper = qtyInput.closest(".cm-variant-item");
            const variantId = itemWrapper ? itemWrapper.getAttribute("data-variant-id") : null;
    
            if (!variantId) return;
    
            if (qty > 0) {
              hasValidQty = true;
               let item = {
                id: variantId,
                quantity: qty
              };
    
              if (sellingplan) {
                item.selling_plan = sellingplan;
              }
          
    
              items.push(item);
            }
          });
          // 4. If all quantities <= 0, alert
              if (!hasValidQty) {
         
                if(inputContainer){
                  inputContainer.classList.add("is--error");
                  inputContainer.scrollIntoView({
                    behavior: 'smooth', // smooth scrolling animation
                    block: 'start'      // align the top of element with the top of viewport
                  });
                }
                const errorEl = document.createElement('div');
                errorEl.className = 'custom-error-message';
                errorEl.textContent = 'Please select at least one item with quantity greater than 0.';
    
                // Optional styling
                errorEl.style.color = 'red';
                errorEl.style.marginBottom = '10px';
                errorEl.style.fontWeight = '500';
    
                // Insert before the button
                btn.parentNode.insertBefore(errorEl, btn);       
                return;
              }
                 btn.classList.add("is--loading");
                
                // 5. Add to cart using theme's default cart-drawer system
                const cart = document.querySelector('cart-drawer');
                
                // Use FormData for compatibility with theme's cart system and sections support
                const formData = new FormData();
                items.forEach((item, index) => {
                  formData.append(`items[${index}][id]`, item.id);
                  formData.append(`items[${index}][quantity]`, item.quantity);
                  if (item.selling_plan) {
                    formData.append(`items[${index}][selling_plan]`, item.selling_plan);
                  }
                });
                
                // Include sections for cart-drawer update (theme's approach)
                if (cart) {
                  const sectionsToRender = cart.getSectionsToRender();
                  // Match theme's exact format: append array directly
                  formData.append('sections', sectionsToRender.map((section) => section.id));
                  formData.append('sections_url', window.location.pathname);
                  cart.setActiveElement(document.activeElement);
                }
                
                // Use theme's fetchConfig if available, otherwise create config for FormData
                const config = typeof fetchConfig !== 'undefined' ? fetchConfig('javascript') : {
                  method: 'POST',
                  headers: { 'Accept': 'application/javascript' }
                };
                
                // Remove Content-Type header to let browser set it for FormData
                if (config.headers && config.headers['Content-Type']) {
                  delete config.headers['Content-Type'];
                }
                config.headers = config.headers || {};
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                config.body = formData;
                
                // Use theme's cart_add_url if available
                const cartAddUrl = (typeof routes !== 'undefined' && routes.cart_add_url) 
                  ? routes.cart_add_url 
                  : window.Shopify.routes.root + 'cart/add';
                
                fetch(cartAddUrl, config)
                  .then((response) => response.json())
                  .then((response) => {
                    if (response.status) {
                      // Error handling
                      btn.classList.remove("is--loading");
                      const errorEl = document.createElement('div');
                      errorEl.className = 'custom-error-message';
                      errorEl.textContent = response.description || response.message || 'Something went wrong. Please try again.';
                      errorEl.style.color = 'red';
                      errorEl.style.marginBottom = '10px';
                      errorEl.style.fontWeight = '500';
                      btn.parentNode.insertBefore(errorEl, btn);
                      
                      // Publish cart error event if available
                      if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish !== 'undefined') {
                        publish(PUB_SUB_EVENTS.cartError, {
                          source: 'cm-add-to-cart',
                          productVariantId: items[0]?.id,
                          errors: response.errors || response.description,
                          message: response.message,
                        });
                      }
                      return;
                    }
                    
                    // Success - update cart drawer using theme's method
                    const productFormEl = btn.closest('product-form');
                    const rawDiscountCode = productFormEl?.dataset?.discountCode || '';
                    const discountCode = rawDiscountCode
                      .split(/[,\n]+/)
                      .map((code) => code.trim())
                      .filter(Boolean)
                      .join(',');

                    if (discountCode) {
                      fetch('/discount/' + encodeURIComponent(discountCode), {
                        method: 'GET',
                        credentials: 'same-origin',
                      })
                        .then(() => {
                          if (typeof window.refreshCart === 'function') {
                            return window.refreshCart({ openDrawer: true });
                          }
                          if (cart) cart.renderContents(response);
                        })
                        .catch((err) => console.error('Discount apply error:', err));
                    } else if (cart) {
                      cart.renderContents(response);
                    } else {
                      // Fallback: redirect to cart page if no cart drawer
                      const cartUrl = (typeof routes !== 'undefined' && routes.cart_url) 
                        ? routes.cart_url 
                        : (typeof KROWN !== 'undefined' && KROWN.settings.routes.cart_url)
                          ? KROWN.settings.routes.cart_url
                          : '/cart';
                      document.location.href = cartUrl;
                      return;
                    }
                    
                    // Publish cart update event if available (theme's pub/sub system)
                    if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish !== 'undefined') {
                      publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: 'cm-add-to-cart',
                        productVariantId: items[0]?.id,
                        cartData: response,
                      });
                    }
                    
                    // Track add to cart event
                    if (window.cartTracking && typeof window.cartTracking.trackAddToCart === 'function') {
                      const addedItem = response.items?.find(item => 
                        item.variant_id?.toString() === items[0]?.id?.toString() ||
                        item.id?.toString() === items[0]?.id?.toString()
                      );
                      if (addedItem) {
                        window.cartTracking.trackAddToCart(response, addedItem);
                      } else {
                        window.cartTracking.trackAddToCart(response);
                      }
                    }
                    
                    // a11y
                    if (document.getElementById('screen-reader-info')) {
                      document.getElementById('screen-reader-info').innerText = 
                        (typeof KROWN !== 'undefined' && KROWN.settings.locales.cart_announcement) 
                          ? KROWN.settings.locales.cart_announcement 
                          : 'Item added to cart';
                      setTimeout(() => {
                        document.getElementById('screen-reader-info').innerText = '';
                      }, 1000);
                    }
                  })
                  .catch((err) => {
                    console.error("Add to cart error:", err);
                    btn.classList.remove("is--loading");
                    const errorEl = document.createElement('div');
                    errorEl.className = 'custom-error-message';
                    errorEl.textContent = 'Something went wrong. Please try again.';
                    errorEl.style.color = 'red';
                    errorEl.style.marginBottom = '10px';
                    errorEl.style.fontWeight = '500';
                    btn.parentNode.insertBefore(errorEl, btn);
                  })
                  .finally(() => {
                    btn.classList.remove("is--loading");
                  });
                  
        });
      });
    
      if (window.location.hash === '#faqs-section') {
        let checkfaq = movetofaq();
          if(!checkfaq){
          }
      }
    });
    


    /*********************
     FREEBIES PROGRESS BAR CONTROLLER
     - does NOT replace existing listeners
     - just adds its own listeners + updater
    *********************/
    document.addEventListener("DOMContentLoaded", function () {
    
      // 1. Get total qty selected in the multi-variant grid
      function getSelectedQtyTotal() {
        let total = 0;
        document.querySelectorAll(".cm-variant-qty").forEach(function (qtyInput) {
          let qty = parseInt(qtyInput.value, 10) || 0;
          total += qty;
        });
        return total;
      }
    
      // 2. Update the text + image under the Key Benefits section
      function updateFreebiesProgressUI() {
    
        const wrapper = document.getElementById("pgbar_response");
        const msgEl = document.getElementById("freebies_progress_msg");
        const fillEl = document.getElementById("freebies_progress_fill");
      
        if (!wrapper || !msgEl || !fillEl) return;
      
        let totalQty = getSelectedQtyTotal();
      
        // Clamp value to 4 max
        if (totalQty > 3) totalQty = 3;
      
        // Get messages from data attributes, with fallback defaults
        const progressMap = {
          0: { 
            percent: 0, 
            text: wrapper.getAttribute("data-progress-msg-0") || "Buy 2 more to get free shipping" 
          },
          1: { 
            percent: 30, 
            text: wrapper.getAttribute("data-progress-msg-1") || "Buy 1 more to get free shipping" 
          },
          2: { 
            percent: 70, 
            text: wrapper.getAttribute("data-progress-msg-2") || "Add one more bag to get 10% off" 
          },
          3: { 
            percent: 100, 
            text: wrapper.getAttribute("data-progress-msg-3") || "🎉 CONGRATS! YOU'VE UNLOCKED ALL REWARDS!" 
          },
        };
      
        const step = progressMap[totalQty];
    
        fillEl.style.width = step.percent + "%";
        msgEl.textContent = step.text;
      }
      
    
      function specialFuncionlity() {
        const pgbar_response = document.querySelector("#pgbar_response");
        const currentquantity = parseInt(pgbar_response.getAttribute("data-cartcount"), 10) || 0;
      
        let addedQty = 0;
      
        document.querySelectorAll(".cm-variant-qty").forEach(function (qtyInput) {
          const qty = parseInt(qtyInput.value, 10) || 0;
          if (qty > 0) addedQty += qty;
        });
      
        pgbar_response.setAttribute("data-cartcount", addedQty + currentquantity);
      }
      
    
      // 3. Watch all qty dropdowns for change and refresh progress bar
      function attachQtyListeners() {
        document.querySelectorAll(".cm-variant-qty").forEach(function (dropdown) {
          dropdown.addEventListener("change", function () {
            specialFuncionlity();
            updateFreebiesProgressUI();
          });
        });
      }
    
      // 4. Initialize on load
      attachQtyListeners();
      updateFreebiesProgressUI();
    });
    
    
    
    // =====  Switch main gallery image when qty is set (>0) for a variant [v2 robust] =====
    (function variantQtyImageSwitcherV2(){
      // Map Variant ID -> unique image slug (substring in its CDN URL)
      let VARIANT_IMG_SLUG = {
        "40461385531477": "BananaMapleFrenchToast",
        "40472683675733": "ChocolateCaramelCandyBar_97b05662-1916-4077-9b4b-0770e21c0884",
        "40549946589269": "CinnamonRoll",
        "40550495191125": "MadagascarVanilla_891ff9ac-ad16-4498-908a-35304225ea3f",
        "40613658165333": "MeltedChocolate_7be8f52b-db42-405a-85b2-030da2d61d66",
        "40722836947029": "StrawberryIceCream_1d9b8de5-7102-4bca-9aee-96d48f9797a7"
      };
    
      // 1) Prefer moving the Splide thumbnail rail
      function goThumbBySlug(slug){
        try{
          if (!window._site1Thumbs || !slug) return false;
          let slides = document.querySelectorAll('#thumbnail-slider .splide__slide');
          if (!slides.length) return false;
    
          let targetIndex = -1;
          for (let i=0;i<slides.length;i++){
            let img = slides[i].querySelector('img');
            if (img && (img.currentSrc || img.src)){
              let src = img.currentSrc || img.src;
              if (src.indexOf(slug) !== -1){ targetIndex = i; break; }
            }
          }
          if (targetIndex >= 0){
            window._site1Thumbs.go(targetIndex);
            return true;
          }
        }catch(e){}
        return false;
      }
    
      // 2) Fallbacks if Splide not available
      function switchMainSrc(src){
        if (!src) return;
        let mainImg =
          document.querySelector('.product-gallery__main img') ||
          document.querySelector('.product__media img') ||
          document.querySelector('.product__media-item img') ||
          document.querySelector('.product__main-photos img') ||
          document.querySelector('#ProductPhotos img') ||
          document.querySelector('.product-gallery img');
        if (mainImg){
          mainImg.src = src;
          if (mainImg.srcset) mainImg.srcset = src;
        }
      }
    
      // NEW: Switch the main CSS Slider panel by image slug
      function activateCssSliderBySlug(slug){
        try{
          if (!slug) return false;
    
          // Prefer the product gallery css-slider; fallback to any css-slider with product-gallery-item
          let slider =
            document.querySelector('.product-gallery .css-slider.enabled') ||
            document.querySelector('#css-slider-template--16506549829717__main') ||
            document.querySelector('.css-slider.enabled');
    
          if (!slider) return false;
    
          // Grab slides inside the css-slider
          let slides = slider.querySelectorAll('.product-gallery-item.css-slide, .product-gallery-item');
          if (!slides.length) return false;
    
          // Find the slide whose <img> src/srcset contains the slug
          let target = null;
          slides.forEach(function(slide){
            let img = slide.querySelector('img');
            let src = (img && (img.currentSrc || img.src)) || '';
            if (!target && src.indexOf(slug) !== -1) target = slide;
          });
          if (!target) return false;
    
          // Toggle active class
          slider.querySelectorAll('.css-slide-active').forEach(function(s){ s.classList.remove('css-slide-active'); });
          target.classList.add('css-slide-active');
    
          // Ensure it scrolls into view (most css-slider setups use scroll-snap)

          // If viewport exists, snap horizontally
          let viewport = slider.querySelector('.css-slider-viewport');
          if (viewport && typeof viewport.scrollTo === 'function') {
            viewport.scrollTo({ left: target.offsetLeft, behavior: 'auto' });
          }
    
          return true;
        } catch(e){
          // fail silent → let other fallbacks run
          return false;
        }
      }
    
        // NEW: global helper to switch main image from a full <img> URL
      window._site1ActivateMainByImgSrc = function(src){
        if (!src) return false;
        // try filename slug (works with your css-slider matcher)
        let slug = src.split('/').pop().split('?')[0];
        if (activateCssSliderBySlug(slug)) return true;
        // fallback: hard swap the main <img> if present
        switchMainSrc(src);
        return true;
      };
    
    
      // Simplified: drive main image directly from a concrete image URL,
      // not from a hard-coded slug map.
      function handleQtyChange(target){
        if (!target || !target.matches('.cm-variant-qty')) return;
    
        var qty = parseInt(target.value, 10) || 0;
        if (qty <= 0) return;
    
        var item = target.closest('.cm-variant-item');
        if (!item) return;
    
        // Prefer explicit alternative image URL from data-alt-img
        var src = item.getAttribute('data-alt-img');
    
        // Fallback: use the <img> inside the variant card
        if (!src) {
          var img = item.querySelector('img');
          src = img && (img.currentSrc || img.src);
        }
    
        if (src && window._site1ActivateMainByImgSrc) {
          window._site1ActivateMainByImgSrc(src);
        }
      }
    
      // Change listener for qty selects
      document.addEventListener('change', function(e){
        handleQtyChange(e.target);
      });
    
      // On load, if any qty > 0 (e.g., your default Banana Maple 1), sync image
      function syncOnLoad(){
        let firstPositive = null;
        document.querySelectorAll('.cm-variant-qty').forEach(function(q){
          let v = parseInt(q.value,10) || 0;
          if (!firstPositive && v > 0) firstPositive = q;
        });
        if (firstPositive) handleQtyChange(firstPositive);
      }
    
      if (document.readyState === 'loading'){
        document.addEventListener('DOMContentLoaded', syncOnLoad);
      } else {
        syncOnLoad();
      }
    })();
